import { defineMessages } from "react-intl";

const messages = defineMessages({
  cancel: {
    id: "email.creation.aiInlineWriter.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button tooltip",
  },
  insert: {
    id: "email.creation.aiInlineWriter.insert",
    defaultMessage: "Insert",
    description: "Insert generated content button tooltip",
  },
  promptPlaceholder: {
    id: "email.creation.aiInlineWriter.prompt.placeholder",
    defaultMessage: "What do you want to say?",
    description: "Placeholder for the inline AI writer prompt input",
  },
  stop: {
    id: "email.creation.aiInlineWriter.stop",
    defaultMessage: "Stop",
    description: "Stop generation button tooltip",
  },
  write: {
    id: "email.creation.aiInlineWriter.write",
    defaultMessage: "Write",
    description: "Write button text",
  },
});

export default messages;
